import { CartLinesUpdateEvent, CartErrorEvent } from '@shopify/events';

/* Shared add-to-bag helper for HOVE sections. Uses Horizon's cart events so the drawer and bubble update natively.
   Any button with [data-hv-quick-add="<variant id>"] adds one of that variant. */
async function add(items, sourceEl, { openCart = true } = {}) {
  const el = sourceEl || document.body;
  const sectionIds = [...document.querySelectorAll('cart-items-component')].map((c) => c.dataset.sectionId).filter(Boolean);
  const deferred = CartLinesUpdateEvent.createPromise();
  el.dispatchEvent(new CartLinesUpdateEvent({ action: 'add', context: 'product', lines: items.map((l) => ({ merchandiseId: String(l.id), quantity: l.quantity || 1 })), promise: deferred.promise }));
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  try {
    const res = await fetch((window.Theme?.routes?.cart_add_url) || root + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items, sections: sectionIds.join(','), sections_url: location.pathname })
    });
    const json = await res.json();
    if (!res.ok || json.status) throw Object.assign(new Error(json.description || json.message || 'Could not add to bag'), { code: 'INVALID' });
    const cart = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
    deferred.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: { items: cart.items, source: 'product-form-component', sourceId: el.id || 'hove', itemCount: items.reduce((a, l) => a + (l.quantity || 1), 0), sections: json.sections, didError: false } });
    if (openCart) {
      const cd = document.querySelector('cart-drawer-component'), td = cd?.closest('theme-drawer');
      if (td) { if (!cd.hasAttribute('auto-open')) setTimeout(() => !td.isOpen && td.open?.(), 150); }
      else location.href = (window.Theme?.routes?.cart_url) || root + 'cart';
    }
    return true;
  } catch (e) {
    deferred.reject(e);
    try { el.dispatchEvent(new CartErrorEvent({ error: e.message, code: e.code || 'SERVICE_UNAVAILABLE' })); } catch (_) {}
    throw e;
  }
}

window.HoveCart = { add };

document.addEventListener('click', async (e) => {
  const btn = e.target.closest('[data-hv-quick-add]');
  if (!btn || btn.disabled) return;
  e.preventDefault();
  const id = btn.dataset.hvQuickAdd, label = btn.textContent;
  btn.disabled = true; btn.setAttribute('aria-busy', 'true');
  const err = btn.closest('[data-hv-quick-scope]')?.querySelector('[data-hv-error]');
  if (err) err.textContent = '';
  try { await add([{ id: Number(id), quantity: 1 }], btn); }
  catch (x) { if (err) err.textContent = x.message; }
  finally { btn.disabled = false; btn.removeAttribute('aria-busy'); btn.textContent = label; }
});
